import { render } from "./PromLink.vue?vue&type=template&id=3670b668"
import script from "./PromLink.vue?vue&type=script&lang=js"
export * from "./PromLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__